import uniqBy from 'lodash/uniqBy';

interface IIssuer {
  id: string,
  name: string,
  ticker: string,
  url?: string,
  viewId: string | number,
}

interface IDealWithIssuers {
  primaryIssuer: IIssuer,
  issuers?: IIssuer[],
  additionalIssuers?: IIssuer[],
}

export const collectIssuers = (deal: IDealWithIssuers): IIssuer[] => {
  if (!deal?.primaryIssuer) {
    return [];
  }

  const issuers = deal.issuers || [];
  const additionalIssuers = deal.additionalIssuers || [];

  const allIssuers = [deal.primaryIssuer, ...issuers, ...additionalIssuers];

  return uniqBy(allIssuers, 'id');
};

export const collectValidIssuers = (deal: IDealWithIssuers): IIssuer[] => {
  const allIssuers = collectIssuers(deal);

  return allIssuers.filter((issuer) => issuer?.id);
};
